import React ,{useEffect, useState}from "react";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import List from "@mui/material/List";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { getCarrerasIds} from "../../../services/hipodromo";
import { useParams } from 'react-router-dom';

import {ProximasCarreras} from "../../../interfaces/priximas_carreras.interface";
import moment from "moment";
import Loading from "../../../componetes/loading";
import {getColors} from "../../../componetes/color_racers";

interface Props{
    id: number
}

const Carrera:React.FC<Props> = ({id})=>{

    const [horses, setEjemplares] = useState<ProximasCarreras[]>()
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { hipodromoId } = useParams<{ hipodromoId: string }>();

    useEffect(()=>{
        const ids = async () =>{
            try {
                setIsLoading(true)
                const currentId = hipodromoId ? Number(hipodromoId) : 1;
                const data = await getCarrerasIds(Number(id), currentId)
                const sortedHorses = data.sort((a, b) => a.pro_car_inscripcion - b.pro_car_inscripcion)
                setEjemplares(sortedHorses)
            } catch (error) {
                console.error(error)
            } finally {
                setIsLoading(false)
            }
        }
        ids()
    // eslint-disable-next-line
    }, [id, hipodromoId])

    const MobileView = () => (
        <Box sx={{ maxWidth: 400, margin: "auto", mt: 2, p: 1 }}>
            <Paper sx={{ mb: 2, p: 2, backgroundColor: "#f5f5f5" }}>
                <Typography variant="h6" gutterBottom textAlign="center">
                    🏇 Detalles de la Carrera
                </Typography>
                <Typography variant="body2"><strong>📅 Fecha:</strong> {horses && moment(moment(horses[0].pro_car_fecha, "YYYY-MM-DDTHH:mmZ").utc()).format('DD-MM-YYYY') }</Typography>
                <Typography variant="body2"><strong>📏 Distancia:</strong> {horses && horses[0].pro_car_distancia}m</Typography>
            </Paper>
            <List>
                {horses && horses.map((horse) => {
                    const {color, textColor} = getColors(horse.pro_car_inscripcion)
                    return(
                    <Accordion
                        key={horse.pro_car_inscripcion}
                        sx={{
                            mb: 1,
                            borderLeft: `6px solid ${ color|| '#cccccc'}`
                        }}
                    >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Box sx={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "space-between" }}>
                                <ListItemText color={textColor} primary={`${horse.pro_car_inscripcion}. ${horse.pro_car_eje_name}`} />
                                {horse.resultados && horse.resultados.eje_jin_pre && horse.resultados.eje_jin && horse.resultados.eje_pre ? (
                                    <>
                                        <Chip label={horse.resultados.eje_jin_pre.won + horse.resultados.eje_jin.won + horse.resultados.eje_pre.won} color="success" size="small" />
                                        <Chip label={horse.resultados.eje_jin_pre.second + horse.resultados.eje_jin.second + horse.resultados.eje_pre.second } color="secondary" size="small" />
                                        <Chip label={horse.resultados.eje_jin_pre.third + horse.resultados.eje_jin.third + horse.resultados.eje_pre.third } color="warning" size="small" />
                                        <Chip label={horse.resultados.eje_jin_pre.fourth + horse.resultados.eje_jin.fourth + horse.resultados.eje_pre.fourth } color="default" size="small" />
                                        <Chip label={horse.resultados.eje_jin_pre.fifth + horse.resultados.eje_jin.fifth + horse.resultados.eje_pre.fifth } color="error" size="small" />
                                    </>
                                ) : (
                                    <Typography variant="body2">No hay resultados disponibles</Typography>
                                )}
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Typography variant="body2">👤 <strong>Jinete:</strong> {horse.pro_car_jin_name}</Typography>
                            <Typography variant="body2">🏋️ <strong>Preparador:</strong> {horse.pro_car_pre_name}</Typography>
                        </AccordionDetails>
                    </Accordion>
                )
                })}
            </List>
            <br/>
            <br/>
            <br/>
        </Box>
    );

    const DesktopView = () => (
        <Box sx={{ width: '100%', mt: 2, p: 1 }}>
            <Paper sx={{ mb: 2, p: 2, backgroundColor: "#f5f5f5" }}>
                <Typography variant="h6" gutterBottom textAlign="center">
                    🏇 Detalles de la Carrera
                </Typography>
                <Typography variant="body2"><strong>📅 Fecha:</strong> {horses && moment(moment(horses[0].pro_car_fecha, "YYYY-MM-DDTHH:mmZ").utc()).format('DD-MM-YYYY') }</Typography>
                <Typography variant="body2"><strong>📏 Distancia:</strong> {horses && horses[0].pro_car_distancia}m</Typography>
            </Paper>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Inscripción</TableCell>
                            <TableCell>Ejemplar</TableCell>
                            <TableCell align="right">Jinete</TableCell>
                            <TableCell align="right">Preparador</TableCell>
                            <TableCell align="right">1°</TableCell>
                            <TableCell align="right">2°</TableCell>
                            <TableCell align="right">3°</TableCell>
                            <TableCell align="right">4°</TableCell>
                            <TableCell align="right">5°</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {horses && horses.map((horse) => {
                            const {color, textColor} = getColors(horse.pro_car_inscripcion)
                            console.log(textColor)
                            return (
                                <TableRow
                                    key={horse.pro_car_inscripcion}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 }, borderLeft: `6px solid ${ color|| '#cccccc'}` }}
                                >
                                    <TableCell component="th" scope="row" sx={{ color: "#000" }}>
                                        {horse.pro_car_inscripcion}
                                    </TableCell>
                                    <TableCell sx={{ color: '#000' }}>{horse.pro_car_eje_name}</TableCell>
                                    <TableCell align="right">{horse.pro_car_jin_name}</TableCell>
                                    <TableCell align="right">{horse.pro_car_pre_name}</TableCell>
                                    {horse.resultados && horse.resultados.eje_jin_pre && horse.resultados.eje_jin && horse.resultados.eje_pre ? (
                                        <>
                                            <TableCell align="right"><Chip label={horse.resultados.eje_jin_pre.won + horse.resultados.eje_jin.won + horse.resultados.eje_pre.won} color="success" size="small" /></TableCell>
                                            <TableCell align="right"><Chip label={horse.resultados.eje_jin_pre.second + horse.resultados.eje_jin.second + horse.resultados.eje_pre.second } color="secondary" size="small" /></TableCell>
                                            <TableCell align="right"><Chip label={horse.resultados.eje_jin_pre.third + horse.resultados.eje_jin.third + horse.resultados.eje_pre.third } color="warning" size="small" /></TableCell>
                                            <TableCell align="right"><Chip label={horse.resultados.eje_jin_pre.fourth + horse.resultados.eje_jin.fourth + horse.resultados.eje_pre.fourth } color="default" size="small" /></TableCell>
                                            <TableCell align="right"><Chip label={horse.resultados.eje_jin_pre.fifth + horse.resultados.eje_jin.fifth + horse.resultados.eje_pre.fifth } color="error" size="small" /></TableCell>
                                        </>
                                    ) : (
                                        <>
                                            <TableCell align="right" colSpan={5}><Typography variant="body2">No hay resultados disponibles</Typography></TableCell>
                                        </>
                                    )}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </TableContainer>
            <br/>
            <br/>
            <br/>
        </Box>
    );

    return<>
        {isLoading ? (
            <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                alignItems: 'center', 
                minHeight: '100vh' 
            }}>
                <Loading />
            </Box>
        ) : (
            isMobile ? <MobileView /> : <DesktopView />
        )}
    </>
}

export default Carrera;